<nav class="subnav">
  <ul class="nav">
    <li class="nav-item">
      <a class="nav-link active" [routerLink]="['/contacts/overview']">Übersicht</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" href="#">zuletzt geändert</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" href="#">Kunden</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" href="#">Lieferanten</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" href="#">Behörden</a>
    </li>
  </ul>
</nav>

<main>
  <h2>PHM PPS  <cds-icon shape="two-way-arrows"></cds-icon>  Firma hinzufügen</h2>
  <app-contact-form (submitContact)="createCompany($event)"></app-contact-form>
</main>

